import classnames from "classnames";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { useTranslatedText } from "./useTranslatedText";
import { getCustomerLoyaltyAccess } from "../../utils/loyalty/getCustomerLoyaltyAccess";
import styles from "./ReleaseDateBanner.scss";
import showEarlyAccessBanner from "../../../common/showEarlyAccessBanner/showEarlyAccessBanner";
import ClientOnly from "../../containers/clientOnly/ClientOnly";

const ReleaseDateBanner = () => {
  const { getTranslation, product, isMixAndMatch } = useRuntimeConstants();
  const { customerAccess, endDate } = getCustomerLoyaltyAccess(
    product,
    isMixAndMatch,
  );

  const textToRender = useTranslatedText(
    getTranslation,
    customerAccess,
    endDate,
  );

  if (!showEarlyAccessBanner(product, isMixAndMatch) || !textToRender) {
    return null;
  }

  const accessClass = customerAccess && `access-${customerAccess}`;

  return (
    <ClientOnly>
      <div
        data-testid="release-date-banner"
        className={classnames(styles.releaseDateBanner, styles[accessClass])}
      >
        {textToRender}
      </div>
    </ClientOnly>
  );
};

export default ReleaseDateBanner;
